import { useContext, useRef, useState } from 'react';
import { Portal, Tooltip, useTooltip } from '@chakra-ui/react';
import { PortalContainerContext } from './providers/chakra';
import { useIsTruncated } from './useIsTruncated';

const NO_TRIGGER = { current: null };

const VTooltip = ({
  content,
  showArrow = true,
  contentProps = undefined,
  positioning = { placement: 'top' },
  disabled = undefined,
  showOnlyWhenTruncated = false,
  children,
  ...props
}) => {
  const portalContainerRef = useContext(PortalContainerContext);
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const isTruncated = useIsTruncated(showOnlyWhenTruncated ? triggerRef : NO_TRIGGER);
  const isDisabled = disabled || (showOnlyWhenTruncated && !isTruncated);

  const tooltip = useTooltip({
    open,
    onOpenChange: () => undefined,
    positioning,
    disabled: isDisabled,
    openDelay: 0,
    ...props,
  });

  return (
    <Tooltip.RootProvider value={tooltip} lazyMount unmountOnExit>
      <Tooltip.Trigger
        asChild
        ref={triggerRef}
        onMouseEnter={isDisabled ? undefined : () => setOpen(true)}
        onMouseLeave={isDisabled ? undefined : () => setOpen(false)}
        onPointerUp={
          isDisabled
            ? undefined
            : (event) => event.pointerType === 'touch' && setOpen((prev) => !prev)
        }
      >
        {children}
      </Tooltip.Trigger>
      <Portal container={portalContainerRef}>
        <Tooltip.Positioner>
          <Tooltip.Content {...contentProps}>
            {showArrow && <Tooltip.Arrow />}
            {content}
          </Tooltip.Content>
        </Tooltip.Positioner>
      </Portal>
    </Tooltip.RootProvider>
  );
};

export default VTooltip;
